import { Component, OnInit, ViewChild } from '@angular/core';
import {
  AbstractControl,
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
} from '@angular/forms';
import { ActivatedRoute, ParamMap, Router } from '@angular/router';
import { FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { faRectangleList } from '@fortawesome/free-regular-svg-icons';
import {
  faChalkboardUser,
  faCheck,
  faCheckCircle,
  faCheckDouble,
  faClock,
  faFilePdf,
  faGraduationCap,
  faInfoCircle,
  faLocationDot,
  faSave,
  faStairs,
  faUserNurse,
  faXmark,
  faXmarkCircle,
  IconDefinition,
} from '@fortawesome/free-solid-svg-icons';
import {
  DialogCloseResult,
  DialogRef,
  DialogResult,
  DialogService,
} from '@progress/kendo-angular-dialog';
import { GridComponent } from '@progress/kendo-angular-grid';
import { NotificationService } from '@progress/kendo-angular-notification';
import { SVGIcon } from '@progress/kendo-svg-icons';
import {
  combineLatest,
  filter,
  finalize,
  firstValueFrom,
  Observable,
  takeUntil,
} from 'rxjs';
import { ICancelMeetingResponse } from 'src/app/modules/provider-management/interfaces/cancel-pa-response';
import { ScheduleEventSaveModel } from 'src/app/modules/provider-management/models/schedule-save-model';
import { ProviderManagementService } from 'src/app/modules/provider-management/services/provider-management.service';
import { DocumentService } from 'src/app/services/document.service';
import { ReferenceService } from 'src/app/services/reference.service';
import { EncounterProviderDetailsComponent } from 'src/app/shared/components/encounter-provider-details/encounter-provider-details.component';
import { AuthStore } from 'src/app/stores/auth.store';
import { ReferenceStore } from 'src/app/stores/reference.store';
import {
  createAction,
  editAction,
  reviewAction,
  viewAction,
} from '../../constants/form-controls';
import { SessionType } from 'src/app/modules/provider-management/enums/schedule-enums';
import { EncounterStatus } from '../../enums/encounter';
import { getTimeDiffShort } from '../../functions/time-diff';
import {
  GetEncounterAttendenceDetails,
  IEcnounterMeetingDetails,
} from '../../interfaces/encounter-neeting-details';
import { IReferenceData } from '../../interfaces/form/reference-data.model';
import {
  ActualSessionDetails,
  AttendanceDetails,
  EncounterHistoryState,
  EncounterStudentRequest,
  IAnnualGoalsAddressed,
  IAttendanceFormValue,
  ICptCodesAddressed,
  IMeetingFormData,
  ISaveEncounterRequestDto,
  IServiceEntryDetails,
  PaFormJson,
  PresentDialogResult,
  PresentDialogStudentInfo,
  ReceivingStudentRow,
  StudentPresentSessionDetails,
} from '../../interfaces/service-entry-details';
import { StudentDocument } from '../../interfaces/student-document';
import { User } from '../../models/user';
import { ApplyCptCodesService } from '../../services/apply-cpt-codes.service';
import { EcounterEntryService } from '../../services/ecounter-entry.service';
import { EncounterAttendanceAbsentDialogService } from '../../services/encounter-attendance-absent-dialog.service';
import { EncounterAttendancePresentDialogService } from '../../services/encounter-attendance-present-dialog.service';
import { ProviderAbsenceSchedulerDialogService } from '../../services/encounter-attendance-schedule-dialog.service';
import { AbstractComponent } from '../abstract-component';
import { ApplyCptCodesComponent } from '../apply-cpt-codes/apply-cpt-codes.component';
import { EncounterAttendanceAbsentComponent } from '../encounter-attendance-absent/encounter-attendance-absent.component';
import { EncounterAttendancePresentComponent } from '../encounter-attendance-present/encounter-attendance-present.component';
import { LoadingService } from 'src/app/services/loading.service';
import { PdfAndImageService } from 'src/app/services/pdf-image.service';
import { RoleType } from '../../enums/role-type';
import { AttendancePayload } from '../../models/encounter-model';
import { showAvailabilityNotification } from '../../functions/availability-notification';
import { ProviderAvailabilityResponseItem } from '../../interfaces/provider-seession-avaliability';

@Component({
  selector: 'app-encounter-service-entry',
  templateUrl: './encounter-service-entry.component.html',
  styleUrls: ['./encounter-service-entry.component.scss'],
  standalone: false,
})
export class EncounterServiceEntryComponent
  extends AbstractComponent
  implements OnInit
{
  @ViewChild('attendanceGrid') attendanceGrid: GridComponent;
  public isLoading: boolean = false;
  public chalkBordUser: SVGIcon = this.customFaIcon(faChalkboardUser);
  public clock: SVGIcon = this.customFaIcon(faClock);
  public locationDot: SVGIcon = this.customFaIcon(faLocationDot);
  public stairs: SVGIcon = this.customFaIcon(faStairs);
  public saveIcon: SVGIcon = this.customFaIcon(faSave);
  public checkDoubleIcon: SVGIcon = this.customFaIcon(faCheckDouble);
  public crossIcon: SVGIcon = this.customFaIcon(faXmark);
  public rectangleListIcon: SVGIcon = this.customFaIcon(faRectangleList);
  public infoCircle: SVGIcon = this.customFaIcon(faInfoCircle);
  public checkIcon: SVGIcon = this.customFaIcon(faCheck);
  public checkCircleIcon: SVGIcon = this.customFaIcon(faCheckCircle);
  public xmarkCircleIcon: SVGIcon = this.customFaIcon(faXmarkCircle);

  isCancelFormSubmission: boolean = false;
  isReasonForDelay: boolean = false;
  gridData: AttendanceDetails[] = [];
  attendanceForm!: FormGroup;
  isScheduledTabSelected: boolean = false;
  reasonForDelayInput: string = '';
  serviceTypes: IReferenceData[] = [];
  languages: IReferenceData[] = [];
  public user: User;
  public meetingSk: string;
  public action: string;
  public isReviewAction: boolean = false;
  public isViewAction: boolean = false;
  public isEditAction: boolean = false;
  public isCreateAction: boolean = false;
  public encounterSk: string;
  public meetingDetails: IEcnounterMeetingDetails;
  public approveSubmission: boolean = false;
  public rejectSubmission: boolean = false;
  public approveRejectDialog: boolean = false;
  public inputApproveReject: string = '';
  public serviceEntryDetails: IServiceEntryDetails;
  public todayDate: Date = new Date();
  public loadSpinner: boolean = false;
  public scheduledSessionText: string = '';
  private presentDialogDataByStudent: Record<string, PresentDialogResult> = {};
  private absentDialogDataByStudent: Record<string, any> = {};
  public status: string;
  public initialMeetingDate: string | null = null;
  public initialMeetingStartTime: string | null = null;
  public initialMeetingEndTime: string | null = null;
  public timeMin: Date = new Date(2000, 0, 1, 6, 0, 0); // 6:00 AM
  public timeMax: Date = new Date(2000, 0, 1, 22, 0, 0); // 10:00 PM
  dateRangeError: boolean = false;
  futureTimeError: boolean = false;
  maxDurationError: boolean = false;
  overlapError: boolean = false;
  public EncounterStatus: typeof EncounterStatus = EncounterStatus;
  locationTypes: IReferenceData[] = [];
  readonly encounterDocumentTypeId: number = 143;
  public currentStatusId: EncounterStatus = EncounterStatus.EncounterDraft;
  encounterId: number = 0;
  private readonly cptRequiredServiceTypeIds: number[] = [1, 2, 6, 7, 8, 12];
  public disableApplyCptForAll: boolean = false;
  public scheduledGroupSize: number = 0;
  public actualGroupSize: number = 0;
  public showProviderAbsenceConfirm: boolean = false;
  private pendingAbsentToggle: boolean | null = null;
  public lastSavedTs: string | null = null;
  startOutsideWindowError: boolean = false;
  endOutsideWindowError: boolean = false;
  expectedMandateDuration: number = 0;
  earliestMandateStartDate: Date | null = null;
  earliestMandateEndDate: Date | null = null;
  mandateEndDateError: boolean = false;
  public showStartTimeRequiredError: boolean = false;
  public showEndTimeRequiredError: boolean = false;
  public originalServiceTypeId: number | null = null;
  public isUDOSupervisor: boolean = false;
  public isUDOProvider: boolean = false;
  public approvedSubmission: {
    date: string;
    supervisor: string;
    comments?: string;
  } | null = null;
  public rejectedSubmission: {
    date: string;
    supervisor: string;
    comments?: string;
  } | null = null;
  public sessionTypes: IReferenceData[] = [];
  public meetingFormData: IMeetingFormData | null = null;

  get isServiceTypeReadOnly(): boolean {
    return this.isCreateAction || this.isEditAction;
  }

  public scheduledView: {
    serviceTypeDesc: string | null;
    languageDesc: string | null;
    date: Date | null;
    startTime: Date | null;
    endTime: Date | null;
    locationTypeDesc: string | null;
    location: string | null;
    floorRoom: string | null;
  } | null = null;
  private readonly excludedServiceTypeIdsForMaxDurationError: number[] = [
    3, // Sign Language Interpreter
    4, // Oral Transliterate
    6,
    7,
    9, // Orientation & Mobility Services
    12, // School Nurse
    35,
  ];
  public providerCardTypeDisplay: string = '';
  private mandateDurationBySk: Record<string, number> = {};
  private readonly excludedServiceTypeIdsForDurationMatch: number[] = [
    3,
    4,
  ];

  constructor(
    private library: FaIconLibrary,
    public loadingService: LoadingService,
    public pdfAndImageService: PdfAndImageService,
    private applyCptCodesService: ApplyCptCodesService,
    private encounterAttendancePresentDialogService: EncounterAttendancePresentDialogService,
    private fb: FormBuilder,
    private encounterAttendanceAbsentDialogService: EncounterAttendanceAbsentDialogService,
    private authStore: AuthStore,

    private encounterEntryService: EcounterEntryService,
    public referenceStore: ReferenceStore,
    private referenceService: ReferenceService,
    public activatedRoute: ActivatedRoute,
    private notificationService: NotificationService,
    private router: Router,
    private documentService: DocumentService,
    private providerManagementService: ProviderManagementService,
    private providerAbsenceSchedulerDialog: ProviderAbsenceSchedulerDialogService,
    private dialogService: DialogService,
  ) {
    super();
    this.isLoading = true;
    this.library.addIcons(
      faGraduationCap,
      faUserNurse,
      faInfoCircle,
      faFilePdf,
      faCheckCircle,
      faXmarkCircle,
    );
    this.gridData = [];

    this.action = this.activatedRoute.snapshot.paramMap.get('action') ?? '';
    this.meetingSk =
      this.activatedRoute.snapshot.paramMap.get('meetingSk') ?? '';
    this.encounterSk =
      this.activatedRoute.snapshot.paramMap.get('encounterSk') || '';

    const state: {
      providerId?: string;
      providerName?: string;
      serviceTypeDescription?: string;
      receivingStudents?: ReceivingStudentRow[];
      serviceTypeID?: number;
      languageID?: number;
      languageDescription?: string;
    } = history.state as {
      providerId?: string;
      providerName?: string;
      serviceTypeDescription?: string;
      receivingStudents?: ReceivingStudentRow[];
      serviceTypeID?: number;
      languageID?: number;
      languageDescription?: string;
    };
    const providerId: string = state.providerId ?? null;
    const providerName: string = state.providerName ?? null;
    const serviceTypeDescription: string = state.serviceTypeDescription ?? null;
    const receivingStudents: ReceivingStudentRow[] =
      state.receivingStudents ?? [];
    const serviceTypeID: number =
      state.serviceTypeID ??
      state.receivingStudents?.[0]?.serviceTypeID ??
      null;
    const firstReceiving: ReceivingStudentRow | undefined =
      receivingStudents.length ? receivingStudents[0] : undefined;
    const languageID: number =
      state.languageID ?? (firstReceiving as any)?.mandateLanguageID ?? null;
    const languageDescription: string =
      state.languageDescription ??
      (firstReceiving as any)?.mandateLanguageDecr ??
      null;

    const qp: ParamMap = this.activatedRoute.snapshot.queryParamMap;
    this.initialMeetingDate = qp.get('meetingDate');
    this.initialMeetingStartTime = qp.get('meetingStartTime');
    this.initialMeetingEndTime = qp.get('meetingEndTime');
    const encounterTitle: string | null = qp.get('title');
    const qpProviderId: string | null = qp.get('providerId');
    const qpProviderName: string | null = qp.get('providerName');

    this.isReviewAction = this.action === reviewAction;
    this.isViewAction = this.action === viewAction;
    this.isCreateAction = this.action === createAction;
    this.isEditAction = this.action === editAction;

    const isUnscheduled: boolean = !this.meetingSk;

    if (this.isCreateAction) {
      const firstReceiving: ReceivingStudentRow | undefined =
        receivingStudents.length ? receivingStudents[0] : undefined;

      this.serviceEntryDetails = {
        providerSk: null,
        providerId: isUnscheduled ? '' : (providerId ?? qpProviderId ?? ''),
        providerName: isUnscheduled
          ? (firstReceiving?.currentProviderTitle ?? '')
          : (providerName ?? qpProviderName ?? ''),
        submissionDueDate: null,
        encounterSk: this.encounterSk || null,
        serviceType:
          isUnscheduled && serviceTypeDescription
            ? { id: serviceTypeID, description: serviceTypeDescription }
            : null,
        language:
          isUnscheduled && languageDescription
            ? { id: languageID, description: languageDescription }
            : null,
        getScheduledSessionDetails: null,
        getActualSessionDetails: null,
        getAttendenceDetails: [],
        timespent: 0,
      } as IServiceEntryDetails;
    }

    // 2) For UNSCHEDULED ONLY: use providerSk and call API
    if (isUnscheduled && firstReceiving?.providerSk) {
      this.encounterEntryService
        .getProviderId(firstReceiving.providerSk)
        .pipe(takeUntil(this.componentDestroyed))
        .subscribe({
          next: (res: string | null) => {
            if (!res) return;
            this.serviceEntryDetails = {
              ...this.serviceEntryDetails,
              providerId: res,
            };
          },
        });
    }

    this.authStore.UserInfo$.pipe(filter((user: User) => !!user)).subscribe(
      (userInfo: User) => {
        this.user = userInfo;

        if (this.isUnscheduledEncounter) {
          this.providerCardTypeDisplay =
            userInfo.userRoles?.[0]?.roleDescription ?? '';
        } else if (encounterTitle) {
          this.providerCardTypeDisplay = encounterTitle;
        }

        if (
          !this.isUnscheduledEncounter &&
          this.isCreateAction &&
          userInfo.providerSk
        ) {
          this.encounterEntryService
            .getProviderId(userInfo.providerSk)
            .pipe(takeUntil(this.componentDestroyed))
            .subscribe({
              next: (res: string | null) => {
                if (!res) return;
                this.serviceEntryDetails = {
                  ...this.serviceEntryDetails,
                  providerId: res,
                };
              },
            });
        }

        this.getServiceTypes();

        // NEW: load UDO provider details
        if (this.user?.providerSk) {
          this.encounterEntryService
            .getUDOProviderdetails(this.user.providerSk)
            .pipe(takeUntil(this.componentDestroyed))
            .subscribe((udo) => {
              this.isUDOSupervisor = !!udo?.isUDOSupervisor;
              this.isUDOProvider = !!udo?.isUDOProvider;
            });
        }
      },
    );
  }

  ngOnInit(): void {
    this.buildForm();
    this.setupAbsentBehavior();
    this.setupSupervisorBehavior();
    this.getDropDownList();

    if (this.isViewAction || this.isReviewAction) {
      this.attendanceForm.disable({ emitEvent: false });
    }

    if (this.isUnscheduledEncounter && this.serviceEntryDetails) {
      this.attendanceForm.patchValue(
        {
          serviceType: this.serviceEntryDetails.serviceType,
          language: this.serviceEntryDetails.language,
        },
        { emitEvent: false },
      );
    }

    if (
      (this.isEditAction || this.isReviewAction || this.isViewAction) &&
      this.encounterSk
    ) {
      // Edit mode: load everything from GetEncounterDetailsById only
      this.getServiceEntryDetails();
    } else if (this.meetingSk) {
      // Create / review / view: use meeting details
      this.getMeetingDetails(this.meetingSk);
    } else {
      // Create unscheduled (from Receiving) – NO meeting call
      const state: {
        receivingStudents?: ReceivingStudentRow[];
      } = history.state as {
        receivingStudents?: ReceivingStudentRow[];
      };
      const receivingData: ReceivingStudentRow[] =
        state.receivingStudents ?? [];

      this.setMandateDurations(receivingData);

      if (receivingData.length) {
        const mapped: AttendanceDetails[] =
          this.mapReceivingToAttendanceDetails(receivingData);
        this.scheduledGroupSize = mapped.length;
        this.loadStudents(mapped);
      } else {
        this.isLoading = false;
      }
    }

    this.studentsFA.valueChanges
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(() => {
        // Handle any changes if needed
      });

    this.attendanceForm
      .get('date')
      ?.valueChanges.subscribe(() => this.validateDateTime());
    this.attendanceForm
      .get('startTime')
      ?.valueChanges.subscribe(() => this.validateDateTime());
    this.attendanceForm
      .get('endTime')
      ?.valueChanges.subscribe(() => this.validateDateTime());

    this.validateDateTime();
    this.updateMandateDateRange();
  }

  private setupAbsentBehavior(): void {
    const absentCtrl = this.attendanceForm.get('absentForSession');

    const hasExistingAttendance = (): boolean => {
      const supervisorCtrl = this.attendanceForm.get('supervisorAttended');
      const anyStudentMarked: boolean = this.studentsFA.controls.some((c) => {
        const fg = c as FormGroup;
        const val = fg.get('attendance')?.value;
        return val === 'Present' || val === 'Absent';
      });

      const anyCptSummary: boolean = this.studentsFA.controls.some((c) => {
        const fg = c as FormGroup;
        const cptCount = fg.get('cptCount')?.value ?? 0;
        return cptCount > 0;
      });

      const supervisor: boolean = !!supervisorCtrl?.value;
      const anyPresentDialog: boolean =
        Object.keys(this.presentDialogDataByStudent).length > 0;
      const anyAbsentDialog: boolean =
        Object.keys(this.absentDialogDataByStudent).length > 0;

      return (
        anyStudentMarked ||
        anyCptSummary ||
        supervisor ||
        anyPresentDialog ||
        anyAbsentDialog
      );
    };

    absentCtrl?.valueChanges.subscribe((isAbsent: boolean) => {
      if (isAbsent && hasExistingAttendance()) {
        this.pendingAbsentToggle = true;
        this.showProviderAbsenceConfirm = true;
        return;
      }

      this.applyAbsentState(!!isAbsent);
    });

    setTimeout(() => {
      this.applyAbsentState(!!absentCtrl?.value);
    });
  }

  private setupSupervisorBehavior(): void {
    const supervisorCtrl = this.attendanceForm.get('supervisorAttended');
    const absentCtrl = this.attendanceForm.get('absentForSession');

    supervisorCtrl?.valueChanges.subscribe((isSupervisor: boolean) => {
      if (isSupervisor) {
        absentCtrl?.patchValue(false, { emitEvent: false });
        absentCtrl?.disable({ emitEvent: false });
      } else {
        absentCtrl?.enable({ emitEvent: false });
      }
    });
  }

  private applyAbsentState(isAbsent: boolean): void {
    const supervisorCtrl = this.attendanceForm.get('supervisorAttended');

    if (isAbsent) {
      supervisorCtrl?.patchValue(false, { emitEvent: false });
      supervisorCtrl?.disable({ emitEvent: false });

      this.studentsFA.controls.forEach((c) => {
        const fg = c as FormGroup;
        const attendanceCtrl = fg.get('attendance');
        const backupCtrl = fg.get('attendanceBackup');

        backupCtrl?.patchValue(attendanceCtrl?.value, { emitEvent: false });
        attendanceCtrl?.patchValue(null, { emitEvent: false });
        attendanceCtrl?.disable({ emitEvent: false });
      });
    } else {
      if (this.isViewAction || this.isReviewAction) {
        return;
      }
      supervisorCtrl?.enable({ emitEvent: false });

      this.studentsFA.controls.forEach((c) => {
        const fg = c as FormGroup;
        const attendanceCtrl = fg.get('attendance');
        const backupCtrl = fg.get('attendanceBackup');

        const previous = backupCtrl?.value ?? null;
        attendanceCtrl?.enable({ emitEvent: false });
        attendanceCtrl?.patchValue(previous, { emitEvent: false });
      });
    }
  }

  onProviderAbsenceCancel(): void {
    const absentCtrl = this.attendanceForm.get('absentForSession');
    this.showProviderAbsenceConfirm = false;
    this.pendingAbsentToggle = null;

    absentCtrl?.patchValue(false, { emitEvent: false });
  }

  onProviderAbsenceConfirm(): void {
    const absentCtrl = this.attendanceForm.get('absentForSession');
    this.showProviderAbsenceConfirm = false;

    this.studentsFA.controls.forEach((c) => {
      const fg = c as FormGroup;

      fg.get('attendance')?.patchValue(null, { emitEvent: false });
      fg.get('attendanceBackup')?.patchValue(null, { emitEvent: false });
      fg.get('cptCount')?.patchValue(0, { emitEvent: false });
      fg.get('cptCodesSummary')?.patchValue([], { emitEvent: false });
      fg.get('cptCodesFull')?.patchValue([], { emitEvent: false });
      fg.get('annualGoalsSummary')?.patchValue([], { emitEvent: false });
      fg.get('sessionNotesSummary')?.patchValue('', { emitEvent: false });
      fg.get('attachmentNames')?.patchValue([], { emitEvent: false });
      fg.get('documents')?.patchValue([], { emitEvent: false });
    });

    this.presentDialogDataByStudent = {};
    this.absentDialogDataByStudent = {};

    absentCtrl?.patchValue(true, { emitEvent: false });
    this.applyAbsentState(true);
    this.pendingAbsentToggle = null;
  }

  public get displayServiceType(): string {
    const first = this.studentsFA?.controls?.[0] as FormGroup | undefined;
    if (first) {
      const mandateSvc = first.get('mandateServiceType')?.value as
        | string
        | null;
      if (mandateSvc && mandateSvc.trim().length > 0) {
        return mandateSvc;
      }
    }
    return '';
  }

  get pageHeading(): string {
    const hasMeeting: boolean = !!this.meetingSk;
    return hasMeeting
      ? 'Scheduled Direct Encounter'
      : 'Unscheduled Direct Encounter';
  }

  public get isUnscheduledEncounter(): boolean {
    // No meetingSk means unscheduled (coming from Receiving)
    return !this.meetingSk;
  }

  public get showUnscheduledNote(): boolean {
    // Only show in create mode and for unscheduled encounters
    return this.isCreateAction && this.isUnscheduledEncounter;
  }

  public showExpectedProgress(dataItem: FormGroup, rowIndex: number): boolean {
    // Always show in edit / review / view
    if (this.isEditAction || this.isReviewAction || this.isViewAction) {
      return true;
    }

    // const attendance = dataItem.get('attendance')?.value as 'Present' | 'Absent' | null;

    const attendance = dataItem.get('attendance')?.value;
    if (attendance === 'Absent') {
      return false;
    }

    // In create mode, only show when there is summary data
    const annualGoals = dataItem.get('annualGoalsSummary')?.value as
      | string[]
      | null;
    const cptCount = dataItem.get('cptCount')?.value as number | null;
    const sessionNotes = dataItem.get('sessionNotesSummary')?.value as
      | string
      | null;
    const reasonForDelay = dataItem.get('reasonForDelayText')?.value as
      | string
      | null;

    const hasPresentSummary =
      !!annualGoals?.length ||
      !!(cptCount && cptCount > 0) ||
      !!sessionNotes ||
      !!reasonForDelay;

    return hasPresentSummary;
  }

  public validateDateTime(): void {
    const date: Date | null = this.attendanceForm.get('date')?.value;
    const start: Date | null = this.attendanceForm.get('startTime')?.value;
    const end: Date | null = this.attendanceForm.get('endTime')?.value;

    const isFormValid: boolean =
      this.attendanceForm.dirty ||
      this.attendanceForm.get('startTime')?.touched ||
      this.attendanceForm.get('endTime')?.touched;

    this.showStartTimeRequiredError = !start && isFormValid;
    this.showEndTimeRequiredError = !end && isFormValid;

    if (!date || !start || !end) {
      this.dateRangeError = false;
      this.futureTimeError = false;
      this.maxDurationError = false;
      this.overlapError = false;
      this.startOutsideWindowError = false;
      this.endOutsideWindowError = false;
      this.mandateEndDateError = false;
      this.expectedMandateDuration = 0;
      this.validateDateRangeOnly();
      return;
    }

    this.dateRangeError = false;
    this.futureTimeError = false;
    this.maxDurationError = false;
    this.overlapError = false;
    this.startOutsideWindowError = false;
    this.endOutsideWindowError = false;
    this.mandateEndDateError = false;
    this.expectedMandateDuration = 0;

    const startEstMinutes: number = this.convertToEstMinutes(start);
    const endEstMinutes: number = this.convertToEstMinutes(end);
    const minMinutes: number = 6 * 60;
    const maxMinutes: number = 22 * 60;

    if (startEstMinutes < minMinutes) {
      this.startOutsideWindowError = true;
    }
    if (endEstMinutes > maxMinutes) {
      this.endOutsideWindowError = true;
    }

    const enteredDuration = endEstMinutes - startEstMinutes;

    if (enteredDuration > 99 || enteredDuration <= 0) {
      this.maxDurationError = true;
    }

    const selectedDate = this.attendanceForm.get('date')?.value;
    if (selectedDate && this.earliestMandateStartDate) {
      const selectedMidnight: Date = new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate(),
      );
      const earliestMidnight: Date = new Date(
        this.earliestMandateStartDate.getFullYear(),
        this.earliestMandateStartDate.getMonth(),
        this.earliestMandateStartDate.getDate(),
      );

      if (selectedMidnight < earliestMidnight) {
        this.dateRangeError = true;
      }
      const todayMidnight = new Date();
      todayMidnight.setHours(0, 0, 0, 0);
      if (selectedMidnight > todayMidnight) {
        this.futureTimeError = true;
      } else {
        this.futureTimeError = false;
      }
    }


    if (selectedDate && this.earliestMandateEndDate) {
  const selectedMidnight: Date = new Date(
    selectedDate.getFullYear(),
    selectedDate.getMonth(),
    selectedDate.getDate(),
  );
  const endMidnight: Date = new Date(
    this.earliestMandateEndDate.getFullYear(),
    this.earliestMandateEndDate.getMonth(),
    this.earliestMandateEndDate.getDate(),
  );

  this.mandateEndDateError = selectedMidnight > endMidnight;
}


    const actualStart: Date = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
      start.getHours(),
      start.getMinutes(),
      start.getSeconds(),
    );
    if (actualStart.getTime() > new Date().getTime()) {
      this.futureTimeError = true;
    }
  }

  private validateDateRangeOnly(): void {
    const date = this.attendanceForm.get('date')?.value;

    if (date && this.earliestMandateStartDate) {
      const selectedMidnight = new Date(
        date.getFullYear(),
        date.getMonth(),
        date.getDate(),
      );
      const earliestMidnight = new Date(
        this.earliestMandateStartDate.getFullYear(),
        this.earliestMandateStartDate.getMonth(),
        this.earliestMandateStartDate.getDate(),
      );

      this.dateRangeError = selectedMidnight < earliestMidnight;
    }

    if (date && this.earliestMandateEndDate) { 
      const selectedMidnight = new Date(date.getFullYear(), date.getMonth(), date.getDate());
      const endMidnight = new Date(
        this.earliestMandateEndDate.getFullYear(),
        this.earliestMandateEndDate.getMonth(),
        this.earliestMandateEndDate.getDate(),
      );
      this.mandateEndDateError = selectedMidnight > endMidnight;
    }
  }

  private convertToEstMinutes(timeDate: Date): number {
    if (!timeDate) return 0;

    // const utcHours = timeDate.getUTCHours();
    // const estHours = utcHours - 5;
    // const estMinutes = timeDate.getUTCMinutes();
    // const totalEstMinutes =
    //   (estHours < 0 ? estHours + 24 : estHours) * 60 + estMinutes;
    // return totalEstMinutes;
    return timeDate.getHours() * 60 + timeDate.getMinutes();
  }

  public get saveStatusId(): EncounterStatus {
    // Edit mode (encounterSk present) -> Modify
    // Create mode (no encounterSk) -> Draft
    return this.encounterSk
      ? EncounterStatus.EncounterModify
      : EncounterStatus.EncounterDraft;
  }

  public get canCertify(): boolean {
    if (this.isReviewAction || this.isViewAction) {
      return false;
    }

    if (this.showStartTimeRequiredError || this.showEndTimeRequiredError) {
      return false;
    }

    if (
      this.futureTimeError ||
      this.maxDurationError ||
      this.overlapError ||
      this.startOutsideWindowError ||
      this.endOutsideWindowError ||
      this.dateRangeError ||
      this.mandateEndDateError ||
      this.mandateDurationMismatch
    ) {
      return false;
    }

    const rawTime = this.attendanceForm.get('timeSpentMinutes')?.value;
    const timeNum: number = Number(rawTime);
    const hasTimeSpent: boolean = !isNaN(timeNum) && timeNum > 0;
    const isAbsent = !!this.attendanceForm.get('absentForSession')?.value;
    const allAttendanceSelected: boolean = this.studentsFA.controls.every(
      (c: AbstractControl) => !!(c as FormGroup).get('attendance')?.value,
    );

    // Location users don't see the time field, so not required
    if (this.locationUser()) {
      return isAbsent ? true : allAttendanceSelected;
    }

    // when absent, only time is required; when not absent, attendance is required
    return isAbsent ? hasTimeSpent : hasTimeSpent && allAttendanceSelected;
  }

  // public get canSave(): boolean {
  //   if (
  //     this.showStartTimeRequiredError ||
  //     this.showEndTimeRequiredError) {
  //     return false;
  //   }

  //   if (
  //     this.futureTimeError ||
  //     this.maxDurationError ||
  //     this.overlapError ||
  //     this.startOutsideWindowError ||
  //     this.endOutsideWindowError ||
  //     this.dateRangeError
  //   ) {
  //     return false;
  //   }

  //   return true;
  // }

  public get canSave(): boolean {
    return true;
  }

  private get isOlderThan45Days(): boolean {
    const date: Date | null = this.attendanceForm.get('date')?.value;
    if (!date) {
      return false;
    }

    const today: Date = new Date();
    const currentMidnight: Date = new Date(
      today.getFullYear(),
      today.getMonth(),
      today.getDate(),
    );
    const actualMidnight: Date = new Date(
      date.getFullYear(),
      date.getMonth(),
      date.getDate(),
    );

    const diffMs: number = currentMidnight.getTime() - actualMidnight.getTime();
    const diffDays: number = diffMs / (1000 * 60 * 60 * 24);

    return diffDays > 45;
  }

  private get historyState(): EncounterHistoryState {
    return history.state as EncounterHistoryState;
  }

  private buildPAMeetingFormJson(): PaFormJson {
    const formValue: {
      serviceType: IReferenceData;
      language: IReferenceData | null;
      locationType: IReferenceData | null;
      date: Date | null;
      startTime: Date | null;
      endTime: Date | null;
      makeupSession: boolean | null;
      teamsMeeting: boolean | null;
      location: string;
      allocatedRoom: string;
      timeSpentMinutes: number | null;
    } = this.attendanceForm.value as {
      serviceType: IReferenceData | null;
      language: IReferenceData | null;
      locationType: IReferenceData | null;
      date: Date | null;
      startTime: Date | null;
      endTime: Date | null;
      makeupSession: boolean | null;
      teamsMeeting: boolean | null;
      location: string;
      allocatedRoom: string;
      timeSpentMinutes: number | null;
    };

    const receivingRows: ReceivingStudentRow[] =
      this.historyState.receivingStudents ?? [];

    const assignments: { assignmentSk: string }[] = receivingRows.map(
      (r: ReceivingStudentRow) => ({ assignmentSk: r.assignmentSk }),
    );

    return {
      sessionType: formValue.serviceType,
      providerAgency: null,
      serviceType: formValue.serviceType,
      language: formValue.language,
      groupSize: this.studentsFA.length.toString(),
      makeupSession: formValue.makeupSession,
      startDate: formValue.date,
      startTime: formValue.startTime,
      endTime: formValue.endTime,
      occurences: { id: 1, description: 'Do Not Repeat' } as IReferenceData,
      studentMandates: receivingRows,
      locationType: formValue.locationType,
      location: formValue.location ?? '',
      floorRoom: formValue.allocatedRoom ?? '',
      teamsMeeting: formValue.teamsMeeting,
      minutes: formValue.timeSpentMinutes ?? null,
      providerSk: this.user.providerSk,
      assignments,
    };
  }

  private mapReceivingToAttendanceDetails(
    receiving: ReceivingStudentRow[],
  ): AttendanceDetails[] {
    return (receiving || []).map(
      (r: ReceivingStudentRow) =>
        ({
          studentSk: r.studentSK,
          studentName: r.studentName,
          studentNycId: r.nycId,
          mandateSk: r.mandateSk,
          mandateName: r.mandateDescription,
          mandateNumber: String(r.mandateID ?? ''),
          mandateServiceTypeId: r.serviceTypeID,
          mandateServiceType: r.mandateType ?? r.serviceType,
          mandateDescription: r.mandateDescription,
          mandateSvcLocation: r.serviceLocation ?? '',
          mandateStartDate: r.serviceStartDate ?? '',
          mandateEndDate: r.serviceEndDate ?? '', 
          iepSk: r.iepSk,
          isPresentOrAbsent: null,
          studentPresentSessionDetails: null,
          status: 'Not Started',
          encounterSk: null,
          isFirstAttend: !r.firstAttendDate,
          isFirstEncounter: !r.earliestEncounterDate,
          reasonForDelayText: '',
          annualGoalsSummary: [],
          cptCount: 0,
          cptCodesSummary: [],
          cptCodesFull: [],
          sessionNotesSummary: '',
          attachmentNames: [],
          previousEncountersCount: 0,
        }) as AttendanceDetails,
    );
  }

  getServiceEntryDetails(): void {
    if (!this.encounterSk) {
      this.isLoading = false;
      return;
    }

    if (this.meetingSk && !Object.keys(this.mandateDurationBySk).length) {
      this.encounterEntryService
        .getMeetingDetails(this.meetingSk)
        .pipe(takeUntil(this.componentDestroyed))
        .subscribe((res: IEcnounterMeetingDetails) => {
          this.setMandateDurations(
            res.formJson
              ? (JSON.parse(res.formJson) as PaFormJson).studentMandates
              : [],
          );
        });
    }

    this.encounterEntryService
      .getServiceEntryDetails(this.encounterSk)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((response: IServiceEntryDetails) => {
        this.serviceEntryDetails = response;
        this.encounterId = response.encounterId ?? 0;
        this.lastSavedTs = response.lastModTS ?? null;

        const details = response.submissionDetails || [];

        // Approved
        const approved = details
          .filter((d) => d?.actionStatus?.description === 'Approved')
          .sort(
            (a, b) =>
              new Date(b.createdDate).getTime() -
              new Date(a.createdDate).getTime(),
          )[0];

        if (approved) {
          const d = new Date(approved.createdDate);
          const mm = String(d.getMonth() + 1).padStart(2, '0');
          const dd = String(d.getDate()).padStart(2, '0');
          const yyyy = d.getFullYear();

          this.approvedSubmission = {
            date: `${mm}/${dd}/${yyyy}`,
            supervisor: approved.createdUser,
            comments: approved.comments || null,
          };
        } else {
          this.approvedSubmission = null;
        }

        // Rejected
        const rejected = details
          .filter((d) => d?.actionStatus?.description === 'Rejected')
          .sort(
            (a, b) =>
              new Date(b.createdDate).getTime() -
              new Date(a.createdDate).getTime(),
          )[0];

        if (rejected) {
          const d = new Date(rejected.createdDate);
          const mm = String(d.getMonth() + 1).padStart(2, '0');
          const dd = String(d.getDate()).padStart(2, '0');
          const yyyy = d.getFullYear();

          this.rejectedSubmission = {
            date: `${mm}/${dd}/${yyyy}`,
            supervisor: rejected.createdUser,
            comments: rejected.comments || null,
          };
        } else {
          this.rejectedSubmission = null;
        }

        this.attendanceForm.patchValue(
          {
            serviceType: response.serviceType || null,
            language: response.language || null,
            timeSpentMinutes:
              response.timespent !== null && response.timespent !== undefined
                ? response.timespent
                : '',
          },
          { emitEvent: false },
        );

        const actual: ActualSessionDetails = response.getActualSessionDetails;
        if (actual) {
          const locationTypeValue: number | IReferenceData | null =
            actual.locationType ?? null;
          const matchedLocationType: IReferenceData | null =
            typeof locationTypeValue === 'number'
              ? (this.locationTypes.find(
                  (lt: IReferenceData) => lt.id === locationTypeValue,
                ) ?? null)
              : (locationTypeValue as IReferenceData | null);

          if (actual.startTime && actual.endTime) {
            this.scheduledSessionText = this.buildScheduledSessionText(
              actual.startTime,
              actual.endTime,
            );
          }

          this.attendanceForm.patchValue(
            {
              date: actual.scheduledDate
                ? new Date(actual.scheduledDate)
                : null,
              startTime: actual.startTime ? new Date(actual.startTime) : null,
              endTime: actual.endTime ? new Date(actual.endTime) : null,
              makeupSession: actual.isMakeUpSession ?? false,
              teamsMeeting: actual.isVirtualSession ?? false,
              absentForSession: actual.isProviderAttendSession ?? false,
              supervisorAttended: actual.isSupervisorAttend ?? false,
              attendedStartTime: actual.supervisorStartTime
                ? new Date(actual.supervisorStartTime)
                : null,
              attendedEndTime: actual.supervisorEndTime
                ? new Date(actual.supervisorEndTime)
                : null,
              location: actual.address ?? '',
              allocatedRoom: actual.allocatedRoom ?? '',
              locationType: matchedLocationType,
            },
            { emitEvent: false },
          );
          this.triggerDateTimeValidation();

          this.scheduledView = {
            serviceTypeDesc: response.serviceType?.description ?? null,
            languageDesc: response.language?.description ?? null,
            date: actual.scheduledDate ? new Date(actual.scheduledDate) : null,
            startTime: actual.startTime ? new Date(actual.startTime) : null,
            endTime: actual.endTime ? new Date(actual.endTime) : null,
            locationTypeDesc: matchedLocationType?.description ?? null,
            location: actual.address ?? null,
            floorRoom: actual.allocatedRoom ?? null,
          };

          // this.validateDateTime();
          if (this.isViewAction || this.isReviewAction) {
            this.attendanceForm.disable({ emitEvent: false });
            this.attendanceForm
              .get('absentForSession')
              ?.disable({ emitEvent: false });
            this.attendanceForm
              .get('supervisorAttended')
              ?.disable({ emitEvent: false });
          }
        }

        const mapped: AttendanceDetails[] = response.getAttendenceDetails.map(
          (x: AttendanceDetails) => {
            const presentRaw: StudentPresentSessionDetails =
              x.studentPresentSessionDetails;
            const normalizedPresent: StudentPresentSessionDetails =
              presentRaw &&
              presentRaw.progressIndicator &&
              presentRaw.progressIndicator.id === 0
                ? {
                    ...presentRaw,
                    progressIndicator: null,
                  }
                : presentRaw;

            const present: StudentPresentSessionDetails = normalizedPresent;

            // only CPTs where cptCodesChecked is true
            const allCpts: ICptCodesAddressed[] =
              present?.cptCodeAddressed || [];
            const selectedCpts: ICptCodesAddressed[] = allCpts.filter(
              (c: ICptCodesAddressed) => c.cptCodesChecked === true,
            );

            return {
              studentSk: x.studentSk,
              studentName: x.studentName,
              studentNycId: x.studentNumber,
              mandateSk: x.mandateSk,
              mandateName: x.mandateDescription ?? x.mandateName,
              mandateNumber: x.mandateNumber,
              mandateServiceTypeId: x.mandateServiceTypeId,
              mandateServiceType: x.mandateServiceType,
              mandateSvcLocation: x.mandateSvcLocation,
              mandateDescription: x.mandateDescription,
              mandateStartDate: x.mandateStartDate,
              mandateEndDate: x.mandateEndDate,
              iepSk: x.iepSk,
              isPresentOrAbsent: x.isPresentOrAbsent,
              studentPresentSessionDetails: present,
              status: x.status,
              encounterSk: x.encounterSk,
              isFirstAttend: present?.isFirstAttend ?? false,
              isFirstEncounter: present?.isFirstEncounter ?? false,
              reasonForDelayText: x.reasonForDelayText ?? '',
              annualGoalsSummary:
                present?.annualGoalsAddressed?.map(
                  (g: IAnnualGoalsAddressed) => g.anualGoalName,
                ) ?? [],
              cptCount: selectedCpts.length,
              cptCodesSummary: selectedCpts.map(
                (c: ICptCodesAddressed) => c.cptCode,
              ),
              cptCodesFull: selectedCpts,
              sessionNotesSummary: present?.sessionNotes ?? '',
              attachmentNames: [],
              previousEncountersCount: x.previousEncountersCount ?? 0,
              sessionTypeId: x.sessionTypeReason?.id ?? null,
            } as AttendanceDetails;
          },
        );

        this.loadStudents(mapped);
        this.updateMandateDateRange();
        this.validateDateTime();
        this.loadStudentDocumentsForGrid();
        this.setupAbsentBehavior();
      });
  }

  public get requiresReasonForDelay(): boolean {
    return this.isOlderThan45Days;
  }

  private loadStudentDocumentsForGrid(): void {
    if (!this.encounterSk) {
      return;
    }

    this.studentsFA.controls.forEach((control: AbstractControl) => {
      const fg: FormGroup = control as FormGroup;
      const studentSk: string = fg.get('studentSk')?.value;

      if (!studentSk) {
        return;
      }

      this.documentService
        .getStudentDocuments(studentSk)
        .pipe(takeUntil(this.componentDestroyed))
        .subscribe((docs: StudentDocument[]) => {
          const encounterDocs: StudentDocument[] = (docs || []).filter(
            (d: StudentDocument) =>
              d.documentType === this.encounterDocumentTypeId,
          );

          const names: any =
            encounterDocs?.map((d: StudentDocument) => d ?? '') ?? [];

          fg.get('documents')?.setValue(docs, { emitEvent: false });
          fg.get('attachmentNames')?.setValue({ names }, { emitEvent: false });
        });
    });
  }

  getDropDownList(): void {
    combineLatest([
      this.referenceService.getDropDownValues('Language'),
      this.referenceService.getDropDownValues('PAScheduleLocationType'),
      this.referenceService.getDropDownValues('EncounterSessionType'),
    ]).subscribe(
      ([language, locationTypes, sessionTypes]: [
        IReferenceData[],
        IReferenceData[],
        IReferenceData[],
      ]) => {
        this.languages = language;
        this.locationTypes = locationTypes;
        this.sessionTypes = sessionTypes;
      },
    );
  }

  getSessionTypeDescription(id: number | null): string {
    if (!id) return '';
    const match = this.sessionTypes?.find((s) => s.id === id);
    return match?.description ?? '';
  }

  getServiceTypes(): void {
    this.encounterEntryService
      .getServiceTypes(this.user.providerSk)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe({
        next: (res: IReferenceData[]) => {
          this.serviceTypes = res;
          if (
            this.isCreateAction &&
            !this.meetingSk &&
            this.serviceEntryDetails?.serviceType
          ) {
            const desc: string =
              this.serviceEntryDetails.serviceType.description;
            const matched: IReferenceData | undefined = this.serviceTypes.find(
              (s: IReferenceData) => s.description === desc,
            );
            if (matched) {
              this.attendanceForm.patchValue(
                { serviceType: matched },
                { emitEvent: false },
              );
            }
          }

          this.applyServiceTypeFromMeeting();
        },
      });
  }

  getMeetingDetails(meetingSk: string): void {
    this.encounterEntryService
      .getMeetingDetails(meetingSk)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe({
        next: (res: IEcnounterMeetingDetails) => {
          this.meetingDetails = res;

          const meetingServiceTypeId: any = res.formJson
            ? JSON.parse(res.formJson).serviceType?.id
            : res.serviceTypeId;
          this.originalServiceTypeId = Number(meetingServiceTypeId) || null;

          this.scheduledSessionText = this.buildScheduledSessionText(
            res.origScheduleDt,
            res.origScheduleEndDt,
          );

          // Create mode: patch date/time (and base fields) from meeting
          if (
            this.isCreateAction &&
            res.origScheduleDt &&
            res.origScheduleEndDt
          ) {
            const start: Date = new Date(res.origScheduleDt);
            const end: Date = new Date(res.origScheduleEndDt);

            this.attendanceForm.patchValue(
              {
                language: this.meetingFormData?.language ?? null,
                locationType: this.meetingFormData?.locationType ?? null,
                location: this.meetingFormData?.location ?? '',
                allocatedRoom: this.meetingFormData?.floorRoom ?? '',
                teamsMeeting: this.meetingFormData?.teamsMeeting ?? null,
                serviceType: this.meetingFormData?.serviceType ?? null,
                makeupSession: this.meetingFormData?.makeupSession ?? null,
                date: start,
                startTime: new Date(
                  2000,
                  0,
                  1,
                  start.getHours(),
                  start.getMinutes(),
                ),
                endTime: new Date(2000, 0, 1, end.getHours(), end.getMinutes()),
              },
              { emitEvent: false },
            );
          }

          // If formJson exists, hydrate meetingFormData and patch non-date fields
          const meetingFormJson: string = res.formJson;
          if (meetingFormJson) {
            this.meetingFormData = JSON.parse(
              meetingFormJson,
            ) as IMeetingFormData;

            this.attendanceForm.patchValue(
              {
                language: this.meetingFormData.language ?? null,
                locationType: this.meetingFormData.locationType ?? null,
                location: this.meetingFormData.location ?? '',
                allocatedRoom: this.meetingFormData.floorRoom ?? '',
                teamsMeeting: this.meetingFormData.teamsMeeting ?? null,
                serviceType: this.meetingFormData.serviceType ?? null,
                makeupSession: this.meetingFormData.makeupSession ?? null,
              },
              { emitEvent: false },
            );
            const meetingFormFull = JSON.parse(meetingFormJson) as PaFormJson;
            const firstMandate = meetingFormFull.studentMandates?.[0];

            this.serviceEntryDetails = {
              ...this.serviceEntryDetails,
              providerName:
                firstMandate?.currentProviderTitle ||
                this.serviceEntryDetails?.providerName ||
                '',
              providerId:
                firstMandate?.providerId ||
                this.serviceEntryDetails?.providerId ||
                '',
              serviceType: this.meetingFormData.serviceType ?? undefined,
            };
          }

          // Build scheduledView ONCE
          const lang = this.attendanceForm.get('language')?.value;
          const locType = this.attendanceForm.get('locationType')?.value;
          const meetingFormFull = JSON.parse(meetingFormJson) as PaFormJson;
          const firstMandate = meetingFormFull.studentMandates?.[0];

          this.setMandateDurations(meetingFormFull.studentMandates);

          this.scheduledView = {
            serviceTypeDesc: firstMandate?.mandateType ?? null,
            languageDesc: firstMandate?.mandateLanguageDecr ?? null,
            date: this.attendanceForm.get('date')?.value ?? null,
            startTime: this.attendanceForm.get('startTime')?.value ?? null,
            endTime: this.attendanceForm.get('endTime')?.value ?? null,
            locationTypeDesc: locType?.description ?? null,
            location: this.attendanceForm.get('location')?.value ?? null,
            floorRoom: this.attendanceForm.get('allocatedRoom')?.value ?? null,
          };

          this.applyServiceTypeFromMeeting();

          if (this.encounterSk && this.isEditAction) {
            this.getServiceEntryDetails();
            return;
          }

          if (this.isCreateAction) {
            this.patchCreateScheduledDateTimes();
          }

          if (res.getEncounterAttendenceDetails?.length) {
            const mapped: AttendanceDetails[] =
              res.getEncounterAttendenceDetails.map(
                (x: GetEncounterAttendenceDetails) =>
                  ({
                    studentSk: x.studentSk,
                    studentName: x.studentName,
                    studentNycId: x.studentNumber,
                    mandateSk: x.mandateSk,
                    mandateName: x.mandateName,
                    mandateNumber: x.mandateNumber,
                    mandateStartDate: x.mandateStartDate,
                    mandateEndDate: x.mandateEndDate, 
                    mandateServiceTypeId: x.mandateServiceTypeId,
                    mandateServiceType: x.mandateServiceType,
                    mandateSvcLocation: x.mandateSvcLocation,
                    mandateDescription: x.mandateDescription,
                    iepSk: x.iepSk,
                    isPresentOrAbsent: x.isPresentOrAbsent,
                    studentPresentSessionDetails:
                      x.studentPresentSessionDetails as unknown as StudentPresentSessionDetails,
                    status: x.status,
                    encounterSk: x.encounterSk,
                    isFirstAttend: x.isFirstAttend ?? false,
                    isFirstEncounter: x.isFirstEncounter ?? false,
                  }) as AttendanceDetails,
              );

            this.loadStudents(mapped);
            this.updateMandateDateRange();
            this.triggerDateTimeValidation();
            this.setupAbsentBehavior();
            const firstAttendance = mapped[0];
            if (!this.serviceEntryDetails) {
              this.serviceEntryDetails = {};
            }
            this.serviceEntryDetails.serviceType = {
              id: firstAttendance.mandateServiceTypeId ?? 0,
              description: firstAttendance.mandateServiceType ?? '',
            };
          } else {
            this.isLoading = false;
          }
        },
        error: () => {
          this.isLoading = false;
        },
      });
  }

  private triggerDateTimeValidation(): void {
    const fields = ['date', 'startTime', 'endTime'];
    fields.forEach((field) => {
      this.attendanceForm
        .get(field)
        ?.updateValueAndValidity({ emitEvent: false });
    });
    this.validateDateTime();
  }

  buildScheduledSessionText(startIso: string, endIso: string): string {
    const start: Date = new Date(startIso);
    const end: Date = new Date(endIso);
    const durationMinutes: number = (end.getTime() - start.getTime()) / 60000;

    // return `${start.toDateString()} ${start.toLocaleTimeString([], {
    //   hour: 'numeric',
    //   minute: '2-digit',
    // })} (${durationMinutes}m)`;
    return `${durationMinutes}m`;
  }

  patchMeetingDetails(meetingData: IMeetingFormData): void {
    this.attendanceForm.patchValue({
      language: meetingData.language || null,
      locationType: meetingData.locationType || null,
      location: meetingData.location || '',
      floorRoom: meetingData.floorRoom || '',
      teamsMeeting: meetingData.teamsMeeting || null,
      serviceType: meetingData.serviceType || null,
      makeupSession: meetingData.makeupSession || null,
      date: new Date(meetingData.startDate),
      startTime: new Date(meetingData.startTime),
      endTime: new Date(meetingData.endTime),
    });
  }

  private patchCreateScheduledDateTimes(): void {
    if (this.initialMeetingDate) {
      this.attendanceForm
        .get('date')
        ?.setValue(new Date(this.initialMeetingDate), { emitEvent: false });
    }
    if (this.initialMeetingStartTime) {
      this.attendanceForm
        .get('startTime')
        ?.setValue(new Date(this.initialMeetingStartTime), {
          emitEvent: false,
        });
    }
    if (this.initialMeetingEndTime) {
      this.attendanceForm
        .get('endTime')
        ?.setValue(new Date(this.initialMeetingEndTime), {
          emitEvent: false,
        });
    }
    this.triggerDateTimeValidation();
  }

  buildForm(): void {
    this.attendanceForm = this.fb.group({
      students: this.fb.array([]),
      timeSpentMinutes: [''],
      serviceType: [''],
      language: [''],
      makeupSession: [false],
      date: [null],
      startTime: [null, Validators.required],
      endTime: [null, Validators.required],
      locationType: [''],
      location: [''],
      allocatedRoom: [''],
      teamsMeeting: [false],
      absentForSession: [false],
      supervisorAttended: [false],
      attendedStartTime: [null],
      attendedEndTime: [null],
    });
  }

  private recalcActualGroupSize(): void {
    this.actualGroupSize = this.studentsFA.controls.filter((c) => {
      const fg = c as FormGroup;
      return fg.get('attendance')?.value === 'Present';
    }).length;
  }

  loadStudents(studentData: AttendanceDetails[]): void {
    studentData.forEach((stu: AttendanceDetails) => {
      const initialAttendance: 'Present' | 'Absent' =
        stu.isPresentOrAbsent === true
          ? 'Present'
          : stu.isPresentOrAbsent === false
            ? 'Absent'
            : null;

      const group: FormGroup = this.fb.group({
        name: [stu.studentName],
        studentId: [stu.studentNycId],
        attendance: [initialAttendance],
        attendanceBackup: [initialAttendance],
        mandatedCode: [stu.mandateName],
        mandatedDescription: [stu.mandateDescription ?? ''],
        mandatedNumber: [stu.mandateNumber],
        mandateStartDate: [stu.mandateStartDate || ''],
        mandateEndDate: [stu.mandateEndDate || ''],  
        mandatedLocation: [stu.mandateSvcLocation ?? ''],
        mandateSk: [stu.mandateSk],
        iepSk: [stu.iepSk],
        status: [stu.status],
        encounterSk: [stu.encounterSk],
        studentSk: [stu.studentSk],

        mandateServiceTypeId: [stu.mandateServiceTypeId],
        mandateServiceType: [stu.mandateServiceType ?? ''],
        studentPresentSessionDetails: [stu.studentPresentSessionDetails],

        isFirstAttend: [stu.isFirstAttend ?? false],
        isFirstEncounter: [stu.isFirstEncounter ?? false],
        reasonForDelayText: [stu.reasonForDelayText ?? ''],
        reasonForDelayId: [stu.reasonForDelayId ?? null],
        reasonForDelayOthers: [''],
        annualGoalsSummary: [stu.annualGoalsSummary ?? []],
        cptCount: [stu.cptCount ?? 0],
        cptCodesSummary: [stu.cptCodesSummary ?? []],
        cptCodesFull: [stu.cptCodesFull ?? []],
        sessionNotesSummary: [stu.sessionNotesSummary ?? ''],
        attachmentNames: [stu.attachmentNames ?? []],
        documents: [stu.documents ?? []],
        previousEncountersCount: [stu.previousEncountersCount ?? 0],
        sessionTypeId: [stu.sessionTypeId ?? null],
      });
      // conditional validator: required only when NOT absent
      const attendanceCtrl = group.get('attendance');
      const absentCtrl = this.attendanceForm.get('absentForSession');
      const updateAttendanceValidator = () => {
        const isAbsent: boolean = !!absentCtrl?.value;
        if (isAbsent) {
          attendanceCtrl?.clearValidators();
        } else {
          attendanceCtrl?.setValidators(Validators.required);
        }
        attendanceCtrl?.updateValueAndValidity({ emitEvent: false });
      };

      updateAttendanceValidator();
      absentCtrl?.valueChanges.subscribe(() => updateAttendanceValidator());

      group.get('attendance')?.valueChanges.subscribe((value: string) => {
        if (this.isReviewAction || this.isViewAction) {
          return;
        }
        const isNotStarted: boolean =
          group.get('status')?.value === 'Not Started' ||
          !group.get('encounterSk')?.value;

        const studentInfo: PresentDialogStudentInfo = {
          studentName: group.get('name')?.value,
          studentId: group.get('studentId')?.value,
          mandateSk: group.get('mandateSk')?.value,
          mandatedCode: group.get('mandatedCode')?.value,
          mandatedNumber: group.get('mandatedNumber')?.value,
          mandatedLocation: group.get('mandatedLocation')?.value,
          mandatedDescription: group.get('mandatedDescription')?.value,
          scheduledSessionText: this.scheduledSessionText,
          studentSk: group.get('studentSk')?.value,
          encounterSk: this.encounterSk || null,
          serviceTypeId: stu.mandateServiceTypeId,
          isFirstAttend: group.get('isFirstAttend')?.value ?? false,
          isFirstEncounter: group.get('isFirstEncounter')?.value ?? false,
          previousEncountersCount:
            group.get('previousEncountersCount')?.value ?? 0,
          isCreateMode: this.isCreateAction,
          isUnscheduledEncounter: this.isUnscheduledEncounter,
        };

        const requireReasonForDelay: boolean = this.isOlderThan45Days;
        if (value === 'Present') {
          this.markPresent(
            stu.studentPresentSessionDetails,
            studentInfo,
            !isNotStarted,
            [],
            requireReasonForDelay,
          );
        } else if (value === 'Absent') {
          const existingSessionTypeId =
            group.get('sessionTypeId')?.value ?? null;
          this.markAbsent(studentInfo, [], existingSessionTypeId);
        }
      });
      this.studentsFA.push(group);
    });

    this.scheduledGroupSize = this.studentsFA.length;
    this.recalcActualGroupSize();

    this.studentsFA.valueChanges
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(() => {
        this.recalcActualGroupSize();
      });

    this.isLoading = false;
    if (this.isEditAction || this.isReviewAction || this.isViewAction) {
      if (this.isReviewAction || this.isViewAction) {
        this.studentsFA.controls.forEach((c) => {
          (c as FormGroup).get('attendance')?.disable({ emitEvent: false });
        });
      }

      setTimeout(() => {
        if (this.attendanceGrid) {
          this.studentsFA.controls.forEach((_, index: number) => {
            this.attendanceGrid.expandRow(index);
          });
        }
      });
    }
    this.updateMandateDateRange();
  }

  private updateMandateDateRange(): void {
    let earliestDate: Date | null = null;
    let earliestEndDate: Date | null = null;

    this.studentsFA.controls.forEach((control: AbstractControl) => {
      const fg = control as FormGroup;

      const rawStart = fg.get('mandateStartDate')?.value;
      if (rawStart) {
        const mandateDate = this.parseMandateDate(rawStart);
        if (mandateDate && (!earliestDate || mandateDate < earliestDate)) {
          earliestDate = mandateDate;
        }
      }

      const rawEnd = fg.get('mandateEndDate')?.value;
      if (rawEnd) {
        const mandateEndDate = this.parseMandateDate(rawEnd);
        if (mandateEndDate && (!earliestEndDate || mandateEndDate < earliestEndDate)) {
          earliestEndDate = mandateEndDate;
        }
      }
    });

    this.earliestMandateStartDate = earliestDate;
    this.earliestMandateEndDate = earliestEndDate;
  }

  private parseMandateDate(raw: unknown): Date | null {
    if (raw instanceof Date) {
      return isNaN(raw.getTime()) ? null : raw;
    }

    if (typeof raw !== 'string') {
      return null;
    }

    const dateStr = raw.trim();
    const parts = dateStr.match(
      /(\d{4})-(\d{2})-(\d{2})\s+(\d{2}):(\d{2}):(\d{2})(\.\d{3})?/,
    );
    if (parts) {
      return new Date(
        parseInt(parts[1]),
        parseInt(parts[2]) - 1,
        parseInt(parts[3]),
        parseInt(parts[4]),
        parseInt(parts[5]),
        parseInt(parts[6]),
      );
    }

    const usMatch = dateStr.match(
      /(\d{1,2})\/(\d{1,2})\/(\d{4})\s+(\d{1,2}):(\d{2}):(\d{2})/,
    );
    if (usMatch) {
      return new Date(
        parseInt(usMatch[3]),
        parseInt(usMatch[1]) - 1,
        parseInt(usMatch[2]),
        parseInt(usMatch[4]),
        parseInt(usMatch[5]),
        parseInt(usMatch[6]),
      );
    }

    const d = new Date(dateStr);
    return isNaN(d.getTime()) ? null : d;
  }

  get studentsFA(): FormArray {
    return this.attendanceForm.get('students') as FormArray;
  }

  customFaIcon(icon: IconDefinition): SVGIcon {
    // FontAwesome icon structure: [width, height, horizontalAlign, verticalAlign, pathData]
    const defaultViewBoxSize: number = 512;
    const heightIndex: number = 1;
    const pathIndex: number = 4;

    const width: number = (icon.icon[0] as number) || defaultViewBoxSize;
    const height: number =
      (icon.icon[heightIndex] as number) || defaultViewBoxSize;
    const pathData: string = (icon.icon[pathIndex] as string) || '';

    return {
      name: icon.iconName,
      content: `<path d="${pathData}" />`,
      viewBox: `0 0 ${width} ${height}`,
    };
  }

  get timeRangeText(): string {
    return getTimeDiffShort(
      this.attendanceForm.get('startTime')?.value,
      this.attendanceForm.get('endTime')?.value,
    );
  }

  get attendedTimeRangeText(): string {
    return getTimeDiffShort(
      this.attendanceForm.get('attendedStartTime')?.value,
      this.attendanceForm.get('attendedEndTime')?.value,
    );
  }

  public get canShowBulkCpt(): boolean {
    const first = this.studentsFA.at(0) as FormGroup | undefined;
    if (!first) {
      return false;
    }
    const serviceTypeId: number = first.get('mandateServiceTypeId')?.value ?? 0;

    return this.cptRequiredServiceTypeIds.includes(serviceTypeId);
  }

  private isCptApplicableFor(
    serviceTypeId: number | null | undefined,
  ): boolean {
    if (serviceTypeId === null || serviceTypeId === undefined) {
      return false;
    }
    return this.cptRequiredServiceTypeIds.includes(Number(serviceTypeId));
  }

  private toLocalIsoWithoutOffset(date: Date | null): string | null {
    if (!date) return null;
    const pad: (n: number) => string = (n: number) =>
      n < 10 ? '0' + n : '' + n;
    return (
      date.getFullYear() +
      '-' +
      pad(date.getMonth() + 1) +
      '-' +
      pad(date.getDate()) +
      'T' +
      pad(date.getHours()) +
      ':' +
      pad(date.getMinutes()) +
      ':00'
    );
  }

  /**
   * Combines the selected date with the time from a time picker.
   * This ensures that when the date is changed, the time components remain correct.
   * @param date - The date selected in the date picker
   * @param time - The time selected in the time picker (which may contain an old date)
   * @returns Formatted ISO string with the selected date and time, or null if either is missing
   */
  private combineDateTime(date: Date | null, time: Date | null): string | null {
    if (!date || !time) return null;

    const pad: (n: number) => string = (n: number) =>
      n < 10 ? '0' + n : '' + n;

    // Use date from the date picker and time from the time picker
    return (
      date.getFullYear() +
      '-' +
      pad(date.getMonth() + 1) +
      '-' +
      pad(date.getDate()) +
      'T' +
      pad(time.getHours()) +
      ':' +
      pad(time.getMinutes()) +
      ':00'
    );
  }

  applyAllCptCode(): void {
    const {
      result$,
      instance,
    }: { result$: Observable<DialogResult>; instance: ApplyCptCodesComponent } =
      this.applyCptCodesService.open();

    const studentSkList: string[] = this.studentsFA.controls
      .map((control: AbstractControl) => {
        const fg: FormGroup = control as FormGroup;
        return fg.get('studentSk')?.value as string | null;
      })
      .filter((v: string | null): v is string => !!v);

    const firstServiceTypeId: number =
      this.studentsFA.at(0)?.get('mandateServiceTypeId')?.value ?? 0;

    instance.encounterSk = this.encounterSk;
    instance.studentSkList = studentSkList;
    instance.serviceTypeId = firstServiceTypeId;

    result$
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((result: DialogResult | DialogCloseResult | FormGroup) => {
        if (result instanceof DialogCloseResult || !result) {
          this.restoreDetailsFocus();
          return;
        }

        if (result) {
          this.notificationService.show({
            content: 'CPT codes applied to all students.',
            cssClass: 'k-notification-success',
            animation: { type: 'slide', duration: 300 },
            position: { horizontal: 'center', vertical: 'top' },
            type: { style: 'success', icon: true },
            hideAfter: 3000,
          });
          if (this.encounterSk) {
            this.isLoading = true;
            this.studentsFA.clear();
            this.getServiceEntryDetails();
          }
        }
      });
  }
  private restoreDetailsFocus(): void {
    setTimeout(() => {
      document.getElementById('apply-cpt-button')?.focus();
    });
  }
  afterOnDestroy(): void {
    // Cleanup if needed
  }

  closeDialog(): void {
    this.isCancelFormSubmission = false;
  }

  onSaveAndExit(): void {
    this.currentStatusId = EncounterStatus.EncounterDraft;
    this.onSaveServiceEntry();
  }

  onExitWithoutSaving(): void {
    this.isCancelFormSubmission = false;
    this.router.navigate(['dashboard/encounters']);
  }

  onCancel(): void {
    if (!this.attendanceForm.dirty) {
      this.router.navigate(['dashboard/encounters']);
      return;
    }
    this.isCancelFormSubmission = true;
  }

  private applyServiceTypeFromMeeting(): void {
    if (!this.meetingDetails) {
      return;
    }

    const meetingFormJson: string = this.meetingDetails.formJson;
    if (!meetingFormJson) {
      return;
    }

    const meetingData: IMeetingFormData = JSON.parse(
      meetingFormJson,
    ) as IMeetingFormData;

    const meetingServiceTypeId: number | undefined =
      meetingData.serviceType?.id !== null
        ? Number(meetingData.serviceType.id)
        : undefined;

    if (!meetingServiceTypeId || !this.serviceTypes?.length) {
      return;
    }

    const matched: IReferenceData | undefined = this.serviceTypes.find(
      (s: IReferenceData) => s.id === meetingServiceTypeId,
    );

    if (matched) {
      this.attendanceForm.patchValue(
        { serviceType: matched },
        { emitEvent: false },
      );
    }
  }

  markPresent(
    studentPresentSessionDetails: StudentPresentSessionDetails,
    studentInfo: PresentDialogStudentInfo,
    showCompare: boolean,
    existingDocuments: StudentDocument[] = [],
    requireReasonForDelay: boolean = false,
    existingDialogResult?: PresentDialogResult | null,
  ): void {
    const form = this.attendanceForm;
    const startDate: Date | null = form.get('date')?.value;
    const startTime: Date | null = form.get('startTime')?.value;
    const endTime: Date | null = form.get('endTime')?.value;

        let durationMinutes = 0;
    let combinedStart: Date | null = null;
    if (startDate && startTime && endTime) {
      combinedStart = new Date(
        startDate.getFullYear(),
        startDate.getMonth(),
        startDate.getDate(),
        startTime.getHours(),
        startTime.getMinutes(),
      );

      const combinedEnd = new Date(
        startDate.getFullYear(),
        startDate.getMonth(),
        startDate.getDate(),
        endTime.getHours(),
        endTime.getMinutes(),
      );

      durationMinutes = Math.round(
        (combinedEnd.getTime() - combinedStart.getTime()) / 60000,
      );
    }

    const studentInfoWithLiveSession: PresentDialogStudentInfo = {
      ...studentInfo,
      scheduledSessionText: durationMinutes
        ? `${durationMinutes}m`
        : studentInfo.scheduledSessionText,
    };

    const {
      result$,
      instance,
    }: {
      result$: Observable<
        DialogResult | DialogCloseResult | PresentDialogResult
      >;
      instance: EncounterAttendancePresentComponent;
    } = this.encounterAttendancePresentDialogService.open();

    instance.studentPresentDetails = studentPresentSessionDetails;
    instance.studentInfo = studentInfoWithLiveSession;
    instance.showComparePreviousSessionNotes =
      showCompare && (studentInfo.previousEncountersCount ?? 0) > 0;
    instance.providerSk = this.user.providerSk;
    instance.existingDocuments = existingDocuments;
    instance.requireReasonForDelay = requireReasonForDelay;
    instance.meetingStartTime = combinedStart ?? startTime;
    instance.isCptApplicable = this.isCptApplicableFor(
      studentInfo.serviceTypeId,
    );

    const serviceTypeDesc =
      this.attendanceForm.get('serviceType')?.value?.description || '';
    instance.serviceTypeDescription = serviceTypeDesc;
    instance.serviceDurationMinutes = durationMinutes;

    if (existingDialogResult) {
      instance.existingDialogResult = existingDialogResult;
    }

    result$
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe(
        (
          resultRaw:
            | DialogResult
            | DialogCloseResult
            | FormGroup
            | PresentDialogResult,
        ) => {
          if (resultRaw instanceof DialogCloseResult) {
            return;
          }

          const result: PresentDialogResult = resultRaw as PresentDialogResult;

          const studentKey: string = studentInfo.studentSk;
          this.presentDialogDataByStudent[studentKey] = result;

          const rowIndex: number = this.studentsFA.controls.findIndex(
            (control: AbstractControl) =>
              (control as FormGroup).get('studentSk')?.value ===
              studentInfo.studentSk,
          );
          if (rowIndex === -1) {
            return;
          }

          const rowFG: FormGroup = this.studentsFA.at(rowIndex) as FormGroup;
          const existingNames: string[] = (rowFG.get('attachmentNames')
            ?.value ?? []) as string[];
          const newNames: string[] = Array.isArray(result.attachments)
            ? result.attachments
                .map((f: File) => f?.name)
                .filter((n): n is string => !!n && n.trim() !== '')
            : [];
          const mergedNames = Array.from(
            new Set([...existingNames, ...newNames]),
          );
          rowFG
            .get('attachmentNames')
            ?.setValue(mergedNames, { emitEvent: false });

          const selectedGoals: {
            anualGoalMandateSk?: string;
            annualGoalMandateSk?: string;
            anualGoalName?: string;
          }[] = result.annualGoals || [];
          rowFG.get('annualGoalsSummary')?.setValue(
            selectedGoals.map((g) => g.anualGoalName),
            { emitEvent: false },
          );

          const selectedCpts: {
            cptCodesMappingId?: number;
            cptCodeMappingId?: number;
            cptCode?: string;
            cptCodeDescription?: string;
          }[] = result.cptCodes || [];

          const isFirstAttend = !!result.isFirstAttend;
          const isFirstEncounter = !!result.isFirstEncounter;

          rowFG.get('cptCount')?.setValue(selectedCpts.length, {
            emitEvent: false,
          });
          rowFG.get('cptCodesSummary')?.setValue(
            selectedCpts.map((c) => `${c.cptCode} - ${c.cptCodeDescription}`),
            { emitEvent: false },
          );
          rowFG
            .get('cptCodesFull')
            ?.setValue(selectedCpts, { emitEvent: false });

          rowFG
            .get('sessionNotesSummary')
            ?.setValue(result.sessionNotes ?? '', { emitEvent: false });
          rowFG
            .get('isFirstAttend')
            ?.setValue(isFirstAttend, { emitEvent: false });
          rowFG
            .get('isFirstEncounter')
            ?.setValue(isFirstEncounter, { emitEvent: false });
          if (!isFirstAttend && isFirstEncounter) {
            rowFG.get('isFirstAttend')?.setValue(false, { emitEvent: false });
          }
          rowFG
            .get('reasonForDelayId')
            ?.setValue(result.reasonForDelayId ?? null, {
              emitEvent: false,
            });
          rowFG
            .get('reasonForDelayText')
            ?.setValue(result.reasonForDelay ?? '', { emitEvent: false });

          rowFG
            .get('reasonForDelayOthers')
            ?.setValue(result.reasonForDelayOthers ?? '', { emitEvent: false });
        },
      );
  }

  public get studentCountLabel(): string {
    const count: number = this.studentsFA?.length ?? 0;
    if (count === 1) {
      return '1 student';
    }
    return `${count} students`;
  }

markAbsent(
  studentInfo: PresentDialogStudentInfo,
  existingDocuments: StudentDocument[] = [],
  existingSessionTypeId: number | null,
): void {
  const form = this.attendanceForm;
  const startDate: Date | null = form.get('date')?.value;
  const startTime: Date | null = form.get('startTime')?.value;
  const endTime: Date | null = form.get('endTime')?.value;

  let combinedStart: Date | null = null;
  let durationMinutes = 0;
  if (startDate && startTime && endTime) {
    combinedStart = new Date(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate(),
      startTime.getHours(),
      startTime.getMinutes(),
    );

    const combinedEnd = new Date(
      startDate.getFullYear(),
      startDate.getMonth(),
      startDate.getDate(),
      endTime.getHours(),
      endTime.getMinutes(),
    );

    durationMinutes = Math.round(
      (combinedEnd.getTime() - combinedStart.getTime()) / 60000,
    );
  }

  const studentInfoWithLiveSession: PresentDialogStudentInfo = {
    ...studentInfo,
    scheduledSessionText: durationMinutes
      ? `${durationMinutes}m`
      : studentInfo.scheduledSessionText,
  };

  const {
    result$,
    instance,
  }: {
    result$: Observable<DialogResult>;
    instance: EncounterAttendanceAbsentComponent;
  } = this.encounterAttendanceAbsentDialogService.open();

  instance.studentInfo = studentInfoWithLiveSession;
  instance.existingDocuments = existingDocuments;
  instance.meetingStartTime = combinedStart ?? startTime ?? this.scheduledView?.startTime ?? null;
    if (existingSessionTypeId !== null) {
      instance.studentAbsentDetails = {
        sessionTypeId: existingSessionTypeId,
        sessionNotes: '',
      };
    }

    result$
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((result: DialogResult | DialogCloseResult | FormGroup) => {
        if (result instanceof DialogCloseResult) {
          return;
        }
        const res: any = result;

        const studentKey: string =
          studentInfo.studentSk ?? studentInfo.studentId;
        this.absentDialogDataByStudent[studentKey] = res;

        const rowIndex = this.studentsFA.controls.findIndex((control) => {
          const fg = control as FormGroup;
          return fg.get('studentSk')?.value === studentInfo.studentSk;
        });
        if (rowIndex === -1) {
          return;
        }

        const rowFG = this.studentsFA.at(rowIndex) as FormGroup;

        if (res.sessionTypeId !== null) {
          rowFG.get('sessionTypeId')?.setValue(res.sessionTypeId, {
            emitEvent: false,
          });
        }

        if (Array.isArray(res.attachments) && res.attachments.length) {
          const names = res.attachments.map((f: File) => f.name);
          rowFG.get('attachmentNames')?.setValue(names, { emitEvent: false });
          rowFG.get('documents')?.setValue(res.attachments, {
            emitEvent: false,
          });
        }

        rowFG.patchValue(
          {
            annualGoalsSummary: [],
            cptCount: 0,
            cptCodesSummary: [],
            cptCodesFull: [],
            sessionNotesSummary: '',
            reasonForDelayText: '',
          },
          { emitEvent: false },
        );

        if (studentKey) {
          delete this.presentDialogDataByStudent[studentKey];
        }
      });
  }

  private uploadEncounterDocuments(): Promise<void> {
    const uploads: Promise<any>[] = [];

    this.studentsFA.controls.forEach((control: AbstractControl) => {
      const group: FormGroup = control as FormGroup;

      const studentSk: string = group.get('studentSk')?.value;
      const mandateSk: string = group.get('mandateSk')?.value;
      const iepSk: string = group.get('iepSk')?.value ?? '';

      // only require studentSk; allow empty nycId
      if (!studentSk) {
        return;
      }

      const presentData = this.presentDialogDataByStudent[studentSk];
      const absentData = this.absentDialogDataByStudent[studentSk];

      const attachments: File[] = [
        ...(presentData?.attachments ?? []),
        ...(absentData?.attachments ?? []),
      ];

      if (!attachments.length) {
        return;
      }

      attachments.forEach((file: File) => {
        if (!file) {
          return;
        }

        const formData: FormData = new FormData();

        formData.append('type', 'standalone');
        formData.append('id', '12345');
        formData.append('studentSk', studentSk);
        formData.append('caseActionSk', iepSk);
        formData.append(
          'documentType',
          this.encounterDocumentTypeId.toString(),
        );

        const formJsonPayload: {
          mandateSk: string;
          providerSk: string;
          packageType: string;
          encounterSk: string;
        } = {
          mandateSk,
          providerSk: this.user.providerSk,
          packageType: 'Encounter',
          encounterSk: this.encounterSk ?? null,
        };

        formData.append('formJson', JSON.stringify(formJsonPayload));
        formData.append('file', file);

        const p = firstValueFrom(this.documentService.uploadDocument(formData));
        uploads.push(p);
      });
    });

    if (!uploads.length) {
      return Promise.resolve();
    }

    return Promise.all(uploads).then(() => {
      // all uploads done
    });
  }

  closeReasonDelayDialog(): void {
    this.isReasonForDelay = false;
  }

  onCertify(): void {
    this.isReasonForDelay = true;
  }

  selectTab(tab: string): void {
    if (this.isUnscheduledEncounter && tab === 'scheduled') {
      return;
    }

    if (this.isReviewAction || this.isViewAction) {
      this.isScheduledTabSelected = tab === 'scheduled';
      this.attendanceForm.disable({ emitEvent: false });
      return;
    }
    if (tab === 'scheduled') {
      this.isScheduledTabSelected = true;
      this.attendanceForm.disable({ emitEvent: false });
    } else if (tab === 'actual') {
      this.isScheduledTabSelected = false;
      this.attendanceForm.enable({ emitEvent: false });
    }
  }

  onReview(action: string): void {
    this.approveRejectDialog = true;
    if (action === 'approve') {
      this.approveSubmission = true;
    }
    if (action === 'reject') {
      this.approveSubmission = false;
    }
  }

  closeApproveRejectDialog(): void {
    this.approveRejectDialog = false;
  }

  public showStudentProgressMetadata(): boolean {
    return true;
  }

  private buildPAMeetingSaveModel(): ScheduleEventSaveModel {
    const formJson: PaFormJson = this.buildPAMeetingFormJson();

    const payload: any = {
      ...formJson,
      meetingType: 7,
      meetingSk: null, // providerMeetingSk should be null for new PA
      personSk: this.user.personSk,
      rescheduleReason: null,
      dateRescheduled: null,
      lastModUser: this.user.displayName,
      lastModTs: new Date().toISOString(),
      subMeetingType: 9,
      isRecurring: false,
      status: 4,
      sessionType: { id: 1, description: null },
      studentSk: null,
    };

    return new ScheduleEventSaveModel(payload);
  }

  public isAllAvailable(data: { availability: string }[]): boolean {
    return data?.every(
      (item: { availability: string }) =>
        item?.availability?.trim() === 'Available',
    );
  }

  onSaveServiceEntry(): void {
    this.validateDateTime();

    if (
      this.isUDOProvider &&
      this.currentStatusId === EncounterStatus.Certified
    ) {
      this.currentStatusId = 8;
    }

    const isAbsent: boolean =
      !!this.attendanceForm.get('absentForSession')?.value;

    // Only enforce attendance validation when NOT absent
    if (!isAbsent) {
      this.studentsFA.controls.forEach((control: AbstractControl) => {
        const fg: FormGroup = control as FormGroup;
        fg.get('attendance')?.markAsTouched();
      });
    }

    this.isLoading = true;
    if (!this.meetingSk && !this.encounterSk) {
      const payload = new AttendancePayload(
        this.user?.providerSk,
        this.attendanceForm?.value,
      );
      this.providerManagementService
        .GetProviderSessionAvailability(payload)
        .subscribe((res: ProviderAvailabilityResponseItem[]) => {
          if (this.isAllAvailable(res)) {
            this.isLoading = true;
            this.makeSaveOrCertifyServiceEntry();
          } else {
            showAvailabilityNotification(res, this.notificationService);
            this.isLoading = false;
          }
        });
    } else {
      this.makeSaveOrCertifyServiceEntry();
    }
  }

  makeSaveOrCertifyServiceEntry(): void {
    const formValue: IAttendanceFormValue =
      this.attendanceForm.getRawValue() as IAttendanceFormValue;

    const timeSpentMinutesRaw: number | string | null =
      formValue.timeSpentMinutes;
    const timeSpentMinutes: number =
      timeSpentMinutesRaw === null ||
      timeSpentMinutesRaw === undefined ||
      timeSpentMinutesRaw === ''
        ? 0
        : Number(timeSpentMinutesRaw);
    const isUnscheduled: boolean = !this.meetingSk;

    const buildBody: (meetingSk: string) => ISaveEncounterRequestDto = (
      meetingSk: string | null,
    ): ISaveEncounterRequestDto => ({
      encounterSk: this.encounterSk || null,
      providerSk: this.user.providerSk,
      meetingSK: meetingSk,
      actualServiceDate: this.toLocalIsoWithoutOffset(formValue.date),
      actualStartTime: this.combineDateTime(
        formValue.date,
        formValue.startTime,
      ),
      actualEndTime: this.combineDateTime(formValue.date, formValue.endTime),
      groupSize: this.studentsFA.length,
      serviceTypeId: this.isUnscheduledEncounter
        ? Number(this.serviceEntryDetails?.serviceType?.id)
        : Number(formValue.serviceType?.id),
      languageId: this.isUnscheduledEncounter
        ? Number(this.serviceEntryDetails?.language?.id)
        : Number(formValue.language?.id),
      locationType: formValue.locationType?.id ?? null,
      locationId: null,
      location: formValue.location ?? '',
      allocatedRoom: formValue.allocatedRoom ?? '',
      lastModuser: this.user.displayName,
      lastModTs: new Date().toISOString(),
      encounterId: this.isEditAction ? (this.encounterId ?? 0) : 0,
      isVirtualAttend: formValue.teamsMeeting ?? false,
      isMakeUpSession: formValue.makeupSession ?? false,
      isProviderAttendSession: formValue.absentForSession ?? false,
      isSupervisorAttendSession: formValue.supervisorAttended ?? false,
      supervisorStartTime: this.combineDateTime(
        formValue.date,
        formValue.attendedStartTime,
      ),
      supervisorEndTime: this.combineDateTime(
        formValue.date,
        formValue.attendedEndTime,
      ),
      timeSpentInCreateSession: isNaN(timeSpentMinutes) ? 0 : timeSpentMinutes,
      isIndirectEncounter: false,
      isDraft: this.currentStatusId !== EncounterStatus.Certified,
      encounterSource: 'Direct',
      statusId: this.currentStatusId,
      encounterStudentRequest: this.buildEncounterStudentRequest(),
    });
    this.uploadEncounterDocuments()
      .then(() => {
        if (!isUnscheduled) {
          // scheduled: existing behavior
          const body: ISaveEncounterRequestDto = buildBody(
            this.meetingSk || null,
          );
          return firstValueFrom(
            this.encounterEntryService.saveEncounterDetails(body),
          );
        }

        // unscheduled: create PA meeting first
        const paModel: ScheduleEventSaveModel = this.buildPAMeetingSaveModel();

        return firstValueFrom(
          this.providerManagementService.submitPAMeeting(paModel),
        ).then((paRes: ICancelMeetingResponse) => {
          const newMeetingSk: string | undefined = paRes.meetingSk;
          this.meetingSk = newMeetingSk ?? null;

          const body: ISaveEncounterRequestDto = buildBody(this.meetingSk);
          return firstValueFrom(
            this.encounterEntryService.saveEncounterDetails(body),
          );
        });
      })
      .then(() => {
        this.isLoading = false;
        this.notificationService.show({
          content: 'Saved successfully.',
          cssClass: 'k-notification-success',
          animation: { type: 'slide', duration: 300 },
          position: { horizontal: 'center', vertical: 'top' },
          type: { style: 'success', icon: true },
          hideAfter: 3000,
        });
        setTimeout(() => this.router.navigate(['dashboard/encounters']), 300);
      })
      .catch(() => {
        this.isLoading = false;
        this.notificationService.show({
          content: 'Failed to save encounter entry. Please try again.',
          cssClass: 'k-notification-error',
          animation: { type: 'slide', duration: 300 },
          position: { horizontal: 'center', vertical: 'top' },
          type: { style: 'error', icon: true },
          hideAfter: 5000,
        });
      });
  }

  private buildEncounterStudentRequest() {
    return this.studentsFA.controls.map((control: AbstractControl) => {
      const group: FormGroup = control as FormGroup;
      const studentSk: string = group.get('studentSk')?.value;
      const mandateSk: string = group.get('mandateSk')?.value;

      const iepSk: string = group.get('iepSk')?.value ?? null;
      const isPresent: boolean = group.get('attendance')?.value === 'Present';

      const presentData: PresentDialogResult =
        this.presentDialogDataByStudent[studentSk] || null;
      const absentData: any = this.absentDialogDataByStudent[studentSk] || null;

      const defaultIsFirstAttend: boolean =
        group.get('isFirstAttend')?.value ?? false;
      const defaultIsFirstEncounter: boolean =
        group.get('isFirstEncounter')?.value ?? false;

      // Fallback: existing present details from API (edit mode)
      const presentFromRow: StudentPresentSessionDetails | null =
        group.get('studentPresentSessionDetails')?.value ?? null;

      const hasDialogData: boolean = !!presentData;
      const hasRowData: boolean = !!presentFromRow;

      const presentSessionDetails:
        | EncounterStudentRequest['presentSessionDetails']
        | null =
        isPresent &&
        (hasDialogData ||
          hasRowData ||
          defaultIsFirstAttend ||
          defaultIsFirstEncounter)
          ? {
              isFirstAttend:
                (hasDialogData
                  ? presentData.isFirstAttend
                  : presentFromRow?.isFirstAttend) ?? defaultIsFirstAttend,

              isFirstEncounter:
                (hasDialogData
                  ? presentData.isFirstEncounter
                  : presentFromRow?.isFirstEncounter) ??
                defaultIsFirstEncounter,

              studentAnnualGoals:
                (hasDialogData
                  ? presentData.annualGoals
                  : presentFromRow?.annualGoalsAddressed
                )?.map((g) => ({
                  studentSk: studentSk,
                  // annualGoalMandateSk:
                  //   g.anualGoalMandateSk ?? g.annualGoalMandateSk,
                  mandateAnnualGoalSeq: g.anualGoalId,
                })) || [],
              studentCPTCodes: (() => {
                let source: ICptCodesAddressed[] = [];
                if (hasDialogData) {
                  source = presentData.cptCodes as ICptCodesAddressed[];
                } else if (hasRowData && presentFromRow?.cptCodeAddressed) {
                  source = presentFromRow.cptCodeAddressed.filter(
                    (c: ICptCodesAddressed) => c.cptCodesChecked === true,
                  );
                }

                return (source ?? [])
                  .filter(
                    (c: ICptCodesAddressed) =>
                      (c.cptCodesMappingId ?? c.cptCodeMappingId) !== null,
                  )
                  .map((c: ICptCodesAddressed) => ({
                    studentSk: studentSk,
                    cptCodeMappingId: (c.cptCodesMappingId ??
                      c.cptCodeMappingId) as number,
                    isActive: true,
                  }));
              })(),
              progressTypeId: hasDialogData
                ? presentData.progressTypeId
                : presentFromRow?.progressIndicator
                  ? Number(presentFromRow.progressIndicator.id)
                  : null,

              sessionNotes: hasDialogData
                ? presentData.sessionNotes
                : (presentFromRow?.sessionNotes ?? ''),
            }
          : null;

      const absentSessionDetails:
        | EncounterStudentRequest['absentSessionDetails']
        | null =
        !isPresent && absentData
          ? {
              sessionTypeId: absentData.sessionTypeId ?? 0,
            }
          : null;

      const reasonForDelayId: number | null =
        presentData?.reasonForDelayId ?? null;
      const reasonForDelayOthers: string =
        presentData?.reasonForDelayOthers ?? presentData?.reasonForDelay ?? '';

      return {
        encounterSk: this.encounterSk || null,
        studentSk: studentSk,
        mandateSk,
        iepSk: iepSk,
        isPresentOrObsent: isPresent,
        presentSessionDetails,
        absentSessionDetails,
        reasonForDelayId,
        reasonForDelayOthers,
        lastModuser: this.user.displayName,
        lastModTs: new Date().toISOString(),
      };
    });
  }

  public onEditExpectedProgress(dataItem: FormGroup): void {
    const attendance: string | null = dataItem.get('attendance')?.value;
    const studentSk: string = dataItem.get('studentSk')?.value;
    const studentId: string = dataItem.get('studentId')?.value;
    const name: string = dataItem.get('name')?.value;
    const mandateSk: string = dataItem.get('mandateSk')?.value;
    const mandatedCode: string = dataItem.get('mandatedCode')?.value;
    const mandatedNumber: string = dataItem.get('mandatedNumber')?.value;
    const mandatedLocation: string = dataItem.get('mandatedLocation')?.value;
    const mandatedDescription: string =
      dataItem.get('mandatedDescription')?.value ?? '';
    const studentInfo: PresentDialogStudentInfo = {
      studentName: name,
      studentId,
      mandateSk,
      mandatedCode,
      mandatedNumber,
      mandatedLocation,
      mandatedDescription,
      scheduledSessionText: this.scheduledSessionText,
      studentSk,
      encounterSk: this.encounterSk || null,
      serviceTypeId: dataItem.get('mandateServiceTypeId')?.value,
      previousEncountersCount:
        dataItem.get('previousEncountersCount')?.value ?? 0,
      isCreateMode: this.isCreateAction,
      isUnscheduledEncounter: this.isUnscheduledEncounter,
    };

    if (attendance === 'Present') {
      const presentDetails: StudentPresentSessionDetails = dataItem.get(
        'studentPresentSessionDetails',
      )?.value;

      const allDocs: StudentDocument[] = dataItem.get('documents')?.value ?? [];

      const encounterDocs: StudentDocument[] = (allDocs || []).filter(
        (d: StudentDocument) => d.documentType === this.encounterDocumentTypeId,
      );

      const existingDialogResult: PresentDialogResult | null =
        this.presentDialogDataByStudent[studentSk] ?? null;

      this.markPresent(
        presentDetails,
        studentInfo,
        true,
        encounterDocs,
        this.requiresReasonForDelay,
        existingDialogResult,
      );
    } else if (attendance === 'Absent') {
      const allDocs: StudentDocument[] = dataItem.get('documents')?.value ?? [];

      const encounterDocs: StudentDocument[] = (allDocs || []).filter(
        (d: StudentDocument) => d.documentType === this.encounterDocumentTypeId,
      );

      const existingSessionTypeId: number | null =
        dataItem.get('sessionTypeId')?.value ?? null;

      this.markAbsent(studentInfo, encounterDocs, existingSessionTypeId);
    }
  }

  onFinalizeApproveReject(): void {
    const statusId: EncounterStatus.Approved | EncounterStatus.Rejected = this
      .approveSubmission
      ? EncounterStatus.Approved
      : EncounterStatus.Rejected;

    const payload: {
      encounterSk: string;
      meetingSk: string;
      providerSk: string;
      actualServiceDate: string;
      statusId: EncounterStatus;
      comments: string;
    } = {
      encounterSk: this.encounterSk,
      meetingSk: this.meetingSk || null,
      providerSk: this.user.providerSk,
      actualServiceDate: this.toLocalIsoWithoutOffset(
        this.attendanceForm.get('date')?.value,
      ),
      statusId,
      comments: this.inputApproveReject || '',
    };

    this.encounterEntryService
      .submitEncounterStatus(payload)
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe({
        next: () => {
          this.notificationService.show({
            content: this.approveSubmission
              ? 'Encounter approved successfully.'
              : 'Encounter rejected successfully.',
            cssClass: 'k-notification-success',
            animation: { type: 'slide', duration: 300 },
            position: { horizontal: 'center', vertical: 'top' },
            type: { style: 'success', icon: true },
            hideAfter: 3000,
          });
          this.approveRejectDialog = false;
          this.router.navigate(['dashboard/encounters']);
        },
        error: () => {
          this.notificationService.show({
            content: 'Failed to submit encounter status. Please try again.',
            cssClass: 'k-notification-error',
            animation: { type: 'slide', duration: 300 },
            position: { horizontal: 'center', vertical: 'top' },
            type: { style: 'error', icon: true },
            hideAfter: 5000,
          });
        },
      });
  }

  onScheduleAbsence(): void {
    const {
      result$,
      instance,
    }: { result$: Observable<DialogResult>; instance: any } =
      this.providerAbsenceSchedulerDialog.open();
    instance.fromCreateServiceEntry = false;
    instance.fromEncounterAttendance = true;
    instance.studentsSelected = false;
    instance.isNew = true;
    instance.schedulerPopupOpen = true;
    instance.displayScheduleTimeButton = false;
    instance.providerManagementInfo = this.providerManagementService.getInfo();
    instance.preselectedSessionTypeId = SessionType.ProviderAbsence;

    result$
      .pipe(takeUntil(this.componentDestroyed))
      .subscribe((res: DialogResult | DialogCloseResult) => {
        if (res instanceof DialogCloseResult) {
          return;
        }
        // handle result if needed
      });
  }

  public openProviderDetailsDialog(): void {
    const providerSk: string =
      this.serviceEntryDetails?.providerSk ?? this.user?.providerSk ?? null;
    const serviceTypeId = this.serviceEntryDetails?.serviceType?.id ?? null;

    if (!providerSk || !serviceTypeId) {
      return;
    }

    const dialogRef: DialogRef = this.dialogService.open({
      title: 'Provider Details',
      content: EncounterProviderDetailsComponent,
      width: '530px',
      height: 'auto',
      maxHeight: '90vh',
    });

    dialogRef.content.instance.providerSk = providerSk;
    dialogRef.content.instance.serviceTypeId = serviceTypeId;
    dialogRef.result.subscribe(() => {
      document.getElementById('provider-details-button')?.focus();
    });
  }

  isExcludedServiceTypeForMaxDurationError(): boolean {
    const serviceTypeId: number =
      this.attendanceForm.get('serviceType')?.value?.id ?? null;

    return this.excludedServiceTypeIdsForMaxDurationError.includes(
      serviceTypeId,
    );
  }
  downloadDocument(documentRow: StudentDocument): void {
    this.loadingService.show();
    this.documentService
      .getDocument(documentRow.documentRef)
      .pipe(finalize(() => this.loadingService.hide()))
      .subscribe((response: Uint8Array<ArrayBufferLike>) => {
        this.pdfAndImageService.download(
          response,
          documentRow.documentFormat,
          documentRow.documentName,
        );
        this.loadingService.hide();
      });
  }

  locationUser(): boolean {
    return this.user?.roleType === RoleType.LocationUser;
  }

  private setMandateDurations(mandates: ReceivingStudentRow[] = []): void {
    mandates.forEach((m: ReceivingStudentRow) => {
      this.mandateDurationBySk[m.mandateSk] = Number(m.duration);
    });
  }

  get mandateDurationMismatch(): boolean {
    const start: Date | null = this.attendanceForm.get('startTime')?.value;
    const end: Date | null = this.attendanceForm.get('endTime')?.value;
    const serviceTypeId: number =
      this.studentsFA.at(0)?.get('mandateServiceTypeId')?.value ?? 0;

    if (
      !start ||
      !end ||
      this.excludedServiceTypeIdsForDurationMatch.includes(serviceTypeId)
    ) {
      return false;
    }

    const entered: number =
      this.convertToEstMinutes(end) - this.convertToEstMinutes(start);

    return this.studentsFA.controls.some((c: AbstractControl) => {
      const mandated: number = this.mandateDurationBySk[c.get('mandateSk')?.value];
      return !!mandated && mandated !== entered;
    });
  }
}
